import { CHATFE_VERSION } from '../version.js';

export function logSdkRuntimeInfoOnce(): void {
  if (typeof window === 'undefined') return;
  // Keep the once-flag under the single gengage namespace rather than on a
  // top-level window.__gengage* global, to avoid polluting the host page.
  if (!window.gengage) window.gengage = {};
  if (!window.gengage.__internal) window.gengage.__internal = {};
  if (window.gengage.__internal.sdkRuntimeInfoLogged) return;
  window.gengage.__internal.sdkRuntimeInfoLogged = true;
  console.info(`[gengage] embedded chat v${CHATFE_VERSION}`);
}
